function showRecoverPasswordForm() {
  $('#recover_password').show();
  $('#customer_login,.customer_login_wrap-1').hide();
}
function showRecoverPasswordFormPopUp(){
  $('.modal-content #recover_password').show();
  $('.modal-content #customer_login,.customer_login_wrap-1').hide();
}
function hideRecoverPasswordFormPopUp(){
  $('.modal-content #recover_password').hide();
  $('.modal-content #customer_login,.customer_login_wrap-1').show();
  $('.modal-content .cm-for-pass').focus();
}
function hideRecoverPasswordForm() {
  $('#recover_password').hide();
  $('#customer_login,.customer_login_wrap-1').show();
  $('.cm-for-pass').focus();
}

// Allow deep linking to the recover password form
if (window.location.hash == '#recover') {
  showRecoverPasswordForm()
}

$(document).ready(function(){
  const isHomePage = document.querySelector('body.template-index');
  if(isHomePage){
    setTimeout(function(){
      const hasRegisterError = document.querySelector('#create_customer input[name="registermodalerror"]');
      if (hasRegisterError) {
        const registerBtn = document.querySelector('.right-groups.header-items .cm-header-register-btn');
        if(registerBtn){
          registerBtn.click();
        }
      }
    },1000);
  }

  const hasRecoverError = document.querySelector('form[action="/account/recover"] .form-errors li');
  const recoverNote = document.querySelector('.reset-form-error');
  if(hasRecoverError && recoverNote){
    recoverNote.textContent = hasRecoverError.innerHTML;
    recoverNote.setAttribute('role', 'alert');
  }

  $('.cm-bottom-log-in .register-now-btn-wrapper .btn,.cm-header-register-btn').click(function(){
    $(this).parents().find('.cm-log-in-right-col').removeClass('loginformactive').addClass('registerformactive');
  });
  $('.cm-bottom-log-in .login-now-btn-wrapper .btn,.cm-header-login-btn').click(function(){
    $(this).parents().find('.cm-log-in-right-col').removeClass('registerformactive').addClass('loginformactive');
  });
  $('.cm-bottom-log-in .login-now-btn-wrapper .btn').click(function(){
    $('.halo_modal-custom .close-modal').focus();
  });

  $("[data-toggle='modal'][data-target='#log-in-form']").click(function(evt){
    evt.preventDefault();
    this.setAttribute('aria-expanded', !JSON.parse(this.getAttribute('aria-expanded')));

    $('.mb-area-mob button.close-mob-trig').click();
    $('#log-in-form').attr('data-source', "footer .footer-pane-item [data-toggle='modal'][data-target='#log-in-form']");
    
    if ($(".modal.halo_modal-custom.cm-log-in-form").hasClass('show')) { 
      _theme.toggleCustomerForm();
      $("body").css({overflow: ""});
    } else {
      _theme.toggleCustomerForm(1, (target, e) => {
        _theme.toggleCustomerForm();
        $("body").css({overflow: ""});
      });
      $("body").css({overflow: "hidden"});
    }
  });

  $(document).on('click', "#log-in-form .close-modal", function() {
    closeModal();
  });
  $(document).on('keydown', "#log-in-form .close-modal", function(e) {
      if (e.key === 'Escape') { closeModal(); }
  });
  function closeModal() {
    _theme.toggleCustomerForm(); 
    $("body").css({overflow: ""}); 
    document.querySelectorAll("[data-toggle='modal'][data-target='#log-in-form']").forEach(elem => {
        elem.setAttribute('aria-expanded', false);
    });
    $('#header-pc-login-modal-cta').focus(); 
  }

  $('form .form-user-consent input[type="radio"]').on('change', function(evt){
    var inputVal = $(this).val().trim();
    var $hiddenInput = $(this).closest('.radiobtngrp').find('input[type="hidden"]')
    if(inputVal == 'yes'){
      $hiddenInput.prop('disabled', false);
    } else {
      $hiddenInput.prop('disabled', true);
    }
  });

  $("#log-in-form form .form-errors li a").click(function(evt){
    evt.preventDefault();
    showRecoverPasswordForm();
  });


    var value = $('.checkres').data('res');
    if(value == true){
      $('.resetsuccessMessage').show();
      $('.showRecoverPasswordForm').on('click',function(){
        $('.resetsuccessMessage').hide();
      })
    }
});